import React, { useEffect, useState } from 'react'
import { YellowButton } from '../../components/YellowButton'
import { Link, useNavigate } from 'react-router-dom'
import { BorderedPageLayout } from '../BorderedPageLayout'
import { InputField } from '../../components/InputField'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { message } from 'antd';
import { NoticeType } from 'antd/es/message/interface'
import { setAlreadyBeen } from '../../features/access/accessSlice'
import { sendAuthPhone, resetLoginPhoneStatus, setCodeIsFreezed, setCodeFreezedSecs, handleLoginForm } from '../../features/login/loginSlice'
import { extractDigits } from '../../utils/normalizePhone'
import { useNavigation } from "react-router-dom";
import { BackButton } from '../../components/BackButton'
import { GooglePlay, CloseIcon, ExpressLogo} from '../../icons'
import useTheme from '../../hooks/useAppColor'
import './banner.css'


export const PhoneLogin = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const getTheme = useTheme()
    
    const { auth } = useAppSelector(state => state.login)
    const disabledBtn = auth.form.phone.length < 11
    const [showBanner, setShowBanner] = useState<boolean>(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [isError, setIsError] = useState<boolean>(false)
    const phone_error = useAppSelector(state => state.login.phone_error)

    const showMessage = (type: NoticeType, content: string) => {
        messageApi.open({
          type: type,
          content: <div style={{ whiteSpace: 'normal', direction: 'ltr' }}>{content}</div>,
          duration: 15
        });
      };
    
    useEffect(()  => {
        if(phone_error.payload){
          setIsError(true)
          showMessage("error", `При попытке авторизоваться произошла ошибка: ${phone_error.payload.details} ${phone_error.payload.code}. Аргументы запроса: ${JSON.stringify(phone_error.meta.arg, null, 2)}`)
        }
    }, [phone_error])

    useEffect(() => {
        if ((!isAndroid() || !isIphone()) && !isStandalone()) {
            setShowBanner(true);
        }
      }, []);

      const handleDownload = (): void => {
        window.location.href = 'intent://play.google.com/store/apps/details?id=com.anonymous.mobileexpresstest&pcampaignid=web_redirect#Intent;scheme=https;action=android.intent.action.VIEW;package=com.android.vending;S.browser_fallback_url=https://play.google.com/store/apps/details?id=com.anonymous.mobileexpresstest&redirect=0;end';
      }

      const handleCloseBanner = (): void => {
        localStorage.setItem('hasClosedBanner', 'true');
        setShowBanner(false);
      }

    const handleSendPhone = () => {
        dispatch(sendAuthPhone({ username: auth.form.phone, role: "врач" }))
    }

    const isAndroid = () => {
        return /Android/i.test(navigator.userAgent);
    };

      const isIphone = () => {
        return /iPhone/i.test(navigator.userAgent);
    };

    const isStandalone = () => {
        return window.matchMedia('(display-mode: standalone)').matches;
    };

    useEffect(() => {
        if (isAndroid() && !isStandalone()) {
            window.location.href = "intent://192.168.88.227:3000/#Intent;scheme=http;package=com.anonymous.mobileexpresstest;end";
        }
      }, []);

    useEffect(() => {
        if (auth.success.phone) {
            navigate("/login/sms")
            dispatch(resetLoginPhoneStatus())
            dispatch(setCodeIsFreezed(true))
            dispatch(setCodeFreezedSecs(5))
        }
    }, [auth.success.phone])

    return (
        <BorderedPageLayout
            contentClassName={"f-column-betw"}
            top={
                <div className='f-row-betw'>
                    <div></div>
                    <h2 className={`title fw-6 ${getTheme("", "c-white")}`}>Вход</h2>
                    <div></div>
                </div>
            }>
            <div className="f-column gap-15">
                <InputField
                    onChange={(e) => {
                        const maskedVal = e.target.value
                        dispatch(handleLoginForm({ key: "maskedPhone", val: maskedVal }))
                        dispatch(handleLoginForm({ key: "phone", val: extractDigits(maskedVal) }))
                    }}
                    value={auth.form.maskedPhone}
                    error={auth.errors.phone}
                    mask='+7(999)999-99-99'
                    label='Введите номер телефона, чтобы войти'
                />
                <YellowButton
                    loading={auth.loading}
                    onClick={handleSendPhone}
                    disabled={disabledBtn}>Продолжить</YellowButton>
            </div>
            <div className='f-column-betw gap-10'>
                {showBanner && (
                <div className={`fz-s' ${getTheme("banner", "banner c-white")}`}>
                <button onClick={handleCloseBanner}><CloseIcon width={16} height={16}/></button>
                <p>Хотите скачать наше приложение?</p>
                <div className='f-row-betw gap-10'><ExpressLogo /> <h3>ЭкспрессНева</h3></div>
                <button onClick={handleDownload}><p>Скачать из <GooglePlay/> Google Play</p></button>
                </div>
                )}
                
                <div>
                    <p className={`fz-s ${getTheme("", "c-white")}`}>
                        Нажимая кнопку «Продолжить», вы соглашаетесь с <Link to={""} className={"c-yellow"}>пользовательским соглашением</Link>, подтверждаете, что ознакомились с политикой  <Link to={""} className={"c-yellow"}>конфиденциальности</Link>, а также даёте согласие на  <Link to={""} className={"c-yellow"}>обработку персональных данных</Link>
                    </p>
                </div>
            </div>
            
        </BorderedPageLayout>
    )
}
